import { IonHeader, IonIcon, IonButton, IonPopover, useIonViewWillLeave, IonGrid, IonRow, IonCol, IonMenu, IonToolbar, IonTitle, IonContent, IonMenuToggle, IonList, IonItem, IonLabel, IonNote, IonListHeader } from '@ionic/react';
import React, { Fragment, useState } from 'react';
import './FellowshipHeader.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { caretDown, ellipsisVertical, people, peopleOutline} from 'ionicons/icons';
import { ReactComponent as NewChatBubbleIcon } from '../../assets/images/chatbubbles-sharp-new.svg';
import IFellowshipGroups from '../../interfaces/IFellowshipGroups';
import { UserRouteInfo, UserRouteKeys } from '../../routes/UserRoutes';
import { useHistory } from 'react-router';

interface IFellowshipHeaderProps extends IRouteInfo {
    groupMenuContents?: JSX.Element[] | JSX.Element,
    accountMenuContents?: JSX.Element[] | JSX.Element,
}

const FellowshipHeader: React.FC<IFellowshipHeaderProps> = (props) => {
    const [showGroupHeaderMenu, setShowGroupHeaderMenu] = useState(false);
    const [groupHeaderMenuEvent, setGroupHeaderMenuEvent] = useState<Event | undefined>(undefined);
    const [showAccountHeaderMenu, setShowAccountHeaderMenu] = useState(false);
    const [accountHeaderMenuEvent, setAccountHeaderMenuEvent] = useState<Event | undefined>(undefined);


    useIonViewWillLeave(() => {
        setShowGroupHeaderMenu(false); 
        setGroupHeaderMenuEvent(undefined);
        setShowAccountHeaderMenu(false); 
        setAccountHeaderMenuEvent(undefined);
    });
  
    return (
        <Fragment>
        <IonHeader mode='ios' className="fellowship-header">
            <IonGrid fixed={true} className="fellowship-header-toolbar">
                <IonRow className="fellowship-header-row">
                    <IonCol className="txt-left">
                        { props.groupMenuContents && 
                            <IonButton fill="clear" onClick={e => {
                                setShowGroupHeaderMenu(true);
                                setGroupHeaderMenuEvent(e.nativeEvent);
                            }} >
                                <IonIcon slot="icon-only" icon={people} />
                            </IonButton>
                        }
                    </IonCol>
                    <IonCol>
                        <div className="header-title">
                            FELLOWSHIP
                        </div>
                    </IonCol>
                    <IonCol className="txt-right">
                        { props.accountMenuContents &&
                            <IonButton fill="clear" onClick={e => {
                                setShowAccountHeaderMenu(true);
                                setAccountHeaderMenuEvent(e.nativeEvent);
                            }}  >
                                <IonIcon slot="icon-only" icon={ellipsisVertical} />
                            </IonButton>
                        }
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonHeader>
            <IonPopover
                mode="md"
                dismissOnSelect={true}
                isOpen={showGroupHeaderMenu}
                event={groupHeaderMenuEvent}
                onDidDismiss={() => {
                    setShowGroupHeaderMenu(false); 
                    setGroupHeaderMenuEvent(undefined);
                }}
            > {props.groupMenuContents}</IonPopover>
            <IonPopover
                mode="md"
                dismissOnSelect={true}
                isOpen={showAccountHeaderMenu}
                event={accountHeaderMenuEvent}
                onDidDismiss={() => {
                    setShowAccountHeaderMenu(false); 
                    setAccountHeaderMenuEvent(undefined);
                }}
            > {props.accountMenuContents}</IonPopover>
        </Fragment>
    );
};

export default FellowshipHeader;